// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"476c1816","746":"e53b3eb9","787":"765520fe"}[chunkId] + ".chunk.js";
};